module.exports = __webpack_public_path__ + "fonts/Univers-LT-Std-65-Bold.0464cec.otf";